module.exports = __webpack_public_path__ + "static/img/youngIcon4.7af1f013.png";